/**
 * Web-only login art handoff state.
 * Keeps the animated ribbon mounted in the nav shell across Login → Dashboard.
 */

export type LoginArtPhase = 'hidden' | 'active' | 'dimming';

type Listener = (phase: LoginArtPhase) => void;

let phase: LoginArtPhase = 'hidden';
const listeners = new Set<Listener>();

export function getLoginArtPhase(): LoginArtPhase {
  return phase;
}

function setPhase(next: LoginArtPhase): void {
  if (phase === next) return;
  phase = next;
  listeners.forEach((listener) => listener(phase));
}

export function subscribeLoginArtPhase(listener: Listener): () => void {
  listeners.add(listener);
  listener(phase);
  return () => {
    listeners.delete(listener);
  };
}

/** Show full-intensity art behind the login UI. */
export function activateLoginArt(): void {
  setPhase('active');
}

/**
 * Raise art as a brief curtain over the mounting dashboard, then fade/dim out.
 * Call immediately before navigateToRootDashboard reset on web.
 * Forces dimming even if art was never activated (curtain still covers the cut).
 */
export function beginLoginArtDim(): void {
  setPhase('dimming');
}

export function hideLoginArt(): void {
  setPhase('hidden');
}
